import './bootstrap'
import './libs/axios'

import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import * as BootstrapVueComponents from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'

import Vuex from 'vuex'
import VueInputMask from 'vue-inputmask'

import vSelect from 'vue-select'

import VueToastr from '@deveodk/vue-toastr'
import ToggleButton from 'vue-js-toggle-button'

import {
  VueTables, ServerTable, ClientTable, Event,
} from 'vue-tables-2'

import '../node_modules/@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css'
import './assets/css/main.css'
import './assets/auxiliary/fontawesome/css/all.min.css'
import 'vue-select/dist/vue-select.css'
import '../node_modules/moment/moment'
import JsonViewer from 'vue-json-viewer'
import VueLoading from 'vuejs-loading-plugin'

import * as VueGoogleMaps from 'vue2-google-maps'

import swal from 'sweetalert'
import App from './App.vue'
import mainStore from './store'
import store from './store'
import router from './router'

// Global Components
import './global-components'

// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/toastification'

window.axios = axios
Vue.prototype.$hasAbility = function (ability) {
  return mainStore.getters.can(ability)
}
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBni4q53Pz1X6zwWqQznhNRg2-79ajar6E',
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    /// / If you want to set the version, you can do so:
    // v: '3.26',
  },

  /// / If you intend to programmatically custom event listener code
  /// / (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  /// / instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  /// / you might need to turn this on.
  // autobindAllEvents: false,

  /// / If you want to manually install components, e.g.
  /// / import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  /// / Vue.component('GmapMarker', GmapMarker)
  /// / then disable the following:
  // installComponents: true,
})

// using default options

// overwrite defaults
Vue.use(VueLoading, {
  dark: false, // default false
  text: '', // default 'Loading'
  loading: false, // default false
  background: 'rgb(255,255,255, 0.68)', // set custom background
  classes: ['loadingOverwrite'], // array, object or string
})
Vue.use(JsonViewer)

window.moment = require('moment')

moment.locale('pt-br')

const translation = {
  count: 'Mostrando {from} de {to} até {count} de registros',
  filter: 'Pesquisar:',
  filterPlaceholder: 'Pesquisar',
  limit: 'Registros:',
  noResults: 'Nenhum registro encontrado',
  page: 'Página:',
  filterBy: 'Filtrar por {column}',
  // for dropdown pagination filterBy: 'Filter by {column}',
  // Placeholder for search fields when filtering by column loading:'Loading...',
  // First request to server defaultOption:'Select {column}'
  // default option for list filters }
}

const options = {
  requestFunction(data) {
    // data.token = this.$store.getters.token
    return axios
      .get(this.url, {
        params: data,
      })
      .catch(
        e => {
          this.dispatch('error', e)
          router.push('/login')
        },
      )
  },
  texts: translation,
  pagination: { chunk: 15, dropdown: false, nav: 'scroll' },
  perPage: 10,
  perPageValues: [10, 25, 50, 100],
}

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Componentes BootstrapVue usados no projeto, registrados globalmente.
// Antes cada tela precisava importar e declarar os seus, e esquecer disso
// fazia a tag virar elemento desconhecido: renderizava o conteudo do slot
// sem estilo e atributos como `variant` e `:disabled` eram ignorados, sem
// erro visivel na tela — so um aviso no console.
;[
  'BAvatar',
  'BBadge',
  'BBreadcrumb',
  'BBreadcrumbItem',
  'BButton',
  'BCard',
  'BCardBody',
  'BCardHeader',
  'BCardSubTitle',
  'BCardText',
  'BCardTitle',
  'BCol',
  'BCollapse',
  'BDropdown',
  'BDropdownDivider',
  'BDropdownItem',
  'BForm',
  'BFormCheckbox',
  'BFormGroup',
  'BFormInput',
  'BFormRadio',
  'BFormRadioGroup',
  'BFormSpinbutton',
  'BFormTextarea',
  'BImg',
  'BInputGroup',
  'BInputGroupAppend',
  'BLink',
  'BMedia',
  'BNav',
  'BNavItem',
  'BNavItemDropdown',
  'BNavbar',
  'BNavbarNav',
  'BOverlay',
  'BRow',
  'BSpinner',
  'BTab',
  'BTabs',
  'BTooltip',
].forEach(nome => {
  const componente = BootstrapVueComponents[nome]
  if (componente) Vue.component(nome, componente)
})
Vue.use(ServerTable, options, false, 'bootstrap4', 'footerPagination')

Vue.use(VueToastr)
Vue.use(ToggleButton)

Vue.use(VueInputMask.default)

// Composition API
Vue.use(VueCompositionAPI)
Vue.component('v-select', vSelect)

Vue.use(Vuex)

// import core styles
require('@core/scss/core.scss')
require('@core/scss/base/pages/app-chat-list.scss')
require('@core/scss/base/pages/app-chat.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

// export const store = new Vuex.Store(mainStore);

new Vue({
  router,
  store,
  created() {
    this.$store.dispatch('initialize')
  },
  render: h => h(App),
}).$mount('#app')

Vue.prototype.$message = function (title, msg, type) {
  let newMsg = ''
  if (msg instanceof Object) {
    newMsg += '<ul>'
    for (const key in msg) {
      if (msg.hasOwnProperty(key)) {
        newMsg += '<li>'
        newMsg += msg[key]
        newMsg += '</li>'
      }
    }
    newMsg += '</ul>'
  } else newMsg = msg

  this.$toastr('add', {
    title,
    msg: newMsg,
    clickClose: true,
    timeout: 4000,
    position: 'toast-top-right',
    type,
  })
}

Vue.prototype.$error = function (error) {
  let errors = error.response ? error.response.data : error

  if (typeof errors === 'object') {
    let html = '<ul>'

    $.each(errors, (key, value) => {
      html += `<li>${value[0]}</li>`
    })

    html += '</ul>'

    errors = html
  }

  this.$message(null, errors, 'error')
}
